module.exports = __webpack_public_path__ + "img/get-iphone.a672f05f.png";